import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { columnAvatarConfig, columnAvatarString, swivuGridSorterFn } from "../../other/utils/utils.jsx";
import ColumnBase from "./ColumnBase.jsx";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";

export default class IncentiveUserPermissionColumn extends ColumnBase {
  static get $name() {
    return "IncentiveUserPermissionColumn";
  }

  static get fields() {
    return [
      { name: "swivuListTitle", readOnly: true, type: "string", defaultValue: "Board Users"  },
      { name: "canMultiSelectSwivuList", readOnly: true, defaultValue: true },
      { name: "swivuListSearchKey", readOnly: true, defaultValue: "name" },
    ];
  }

  static get type() {
    return WIDGET_KEYS.incentiveUserPermissionColumn;
  }

  static get defaults() {
    return {
      cellCls: "swivu-recipients-cell gap-[0.3em]",
      flex: "1 1 100%",
      editor: false,
      tooltipRenderer: columnAvatarConfig.tooltipRenderer
    };
  }

  get swivuListItems() {
    return this.project
      .getCrudStore(STORE_KEYS.boardUserStore)
      .query(() => true, true).sort(swivuGridSorterFn.bind({ field: "name" })) || [];
  }

  onLoad(project) {
    this.project = project;
  }

  renderer({ record, size }) {
    if (!record.isGroupHeader && this.project) {
      const userRecords = record[this.field].map((id) => this.project.boardUsersStore.getById(id));

      return userRecords.map(record => columnAvatarConfig.columnAvatarRenderer({
        image: record.profileImageURL,
        name: record.name,
        size: size.configuredHeight,
        archived: record.archived,
        showName: false
      }))
    }
  }

  getSwivuListItemDisplayValue(record) {
    return columnAvatarString(record.name, record.profileImageURL);
  }

  getSelectedSwivuListItem(record) {
    return this.swivuListItems.filter((item) =>
      record[this.field].includes(item?.id)
    );
  }

  onSwivuListSelectionChange(record, usersRecord) {
    record[this.field] = usersRecord.map((item) => item.id);
  }
}

ColumnStore.registerColumnType(IncentiveUserPermissionColumn);